
import Modal from "bootstrap/js/dist/modal";
import { helper } from "../../Helper";
import { Button } from "./Button";

export class Dialog {
    private id: string;
    private modal: HTMLElement | undefined;
    private bootstrapModal: Modal | undefined;

    constructor(private title: string, private body: string, private buttons: Button[] = []) {
        this.id = helper.makeid(10);
        this.createDialog();
    }

    createDialog = () => {
        this.modal = this.dialogTemplate();
        document.body.appendChild(this.modal);
        if (this.buttons.length === 0) {
            const btn = this.renderBtn(new Button("Cancel", "primary"));
            document.getElementById(`btn-holder${this.id}`)?.append(btn);
        } else {
            this.buttons.map((button) => {
                const btn = this.renderBtn(button);
                document.getElementById(`btn-holder${this.id}`)?.append(btn);
            });
        }

        this.bootstrapModal = Modal.getOrCreateInstance(this.modal);

        if (this.modal) {
            this.modal.addEventListener('hide.bs.modal', event => {
                console.log(event);
            });
            this.modal.addEventListener('hidden.bs.modal', event => {
                console.log(event);
                this.bootstrapModal?.dispose();
                this.modal?.remove();
            });
            this.modal.addEventListener('hidePrevented.bs.modal', event => {
                console.log(event);
            });
            this.modal.addEventListener('show.bs.modal', event => {
                console.log(event);
            });
            this.modal.addEventListener('shown.bs.modal', event => {
                console.log(event);
            });
        }
    }

    public show = () => {
        if (this.bootstrapModal instanceof Modal) {
            this.bootstrapModal.show();
        }
    }

    private dialogTemplate = (): HTMLElement => {
        const element = document.createElement("div");
        element.id = "dialog-" + this.id;
        element.classList.add("modal");
        element.classList.add("fade");

        element.innerHTML = `${element.innerHTML}
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="system-modal-title-${this.id}">${this.title}</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                    ${this.body}
                    </div>
                    <div class="modal-footer" id="btn-holder${this.id}"></div>
                </div>
            </div>`;
        return element;
    }

    private renderBtn = (button: Button) => {
        return button.render();
    }
}